export function userDetailsUpdate(send) {
  return (userId, body, ...args) =>
    send(
      {
        path: '/v2/users/{userId}/userDetailsUpdate',
        pathParameters: { userId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
